import { render, staticRenderFns } from "./profile-summary.vue?vue&type=template&id=f2674c02&"
import script from "./profile-summary.vue?vue&type=script&lang=js&"
export * from "./profile-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports